import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Navbar } from '@/components/landing/navbar'
import { Footer } from '@/components/landing/footer'

export const Route = createFileRoute('/legal')({
  component: LegalLayout,
})

function LegalLayout() {
  return (
    <div
      style={{
        background: '#F8FAFF',
        minHeight: '100vh',
        fontFamily: '"Plus Jakarta Sans", "DM Sans", sans-serif',
        color: '#111827',
        overflowX: 'hidden',
      }}
    >
      <Navbar />
      <Outlet />
      <Footer />
    </div>
  )
}
